/* unplugin-vue-components disabled */import { render } from "./AIQuizGenerator.vue?vue&type=template&id=2d8ac805&scoped=true&ts=true"
import script from "./AIQuizGenerator.vue?vue&type=script&lang=ts"
export * from "./AIQuizGenerator.vue?vue&type=script&lang=ts"

import "./AIQuizGenerator.vue?vue&type=style&index=0&id=2d8ac805&lang=scss&scoped=true"
import "./AIQuizGenerator.vue?vue&type=style&index=1&id=2d8ac805&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8ac805"]])

export default __exports__